module.exports = __webpack_public_path__ + "img/huawei.b8c7c68f.jpeg";